import { IGetOrdemCompraInformacaoFaturamentoDropDownUseCase } from "../../../presentation/useCases/read/get_ordem_compra_informacao_faturamento_drop_down_use_case";
import { OrdemCompraInformacaoFaturamentoDropDown } from "../../models/ordem_compra_informacao_faturamento";
import { IComprasRepository } from "../../repositories/compras_repositories";

/**
 * GetOrdemCompraInformacaoFaturamentoDropDownUseCase
 */

export class GetOrdemCompraInformacaoFaturamentoDropDownUseCase
  implements IGetOrdemCompraInformacaoFaturamentoDropDownUseCase {
  constructor(private readonly repository: IComprasRepository) { }

  async getOrdemCompraInformacaoFaturamentoDropDown(
    idOrdemCompra: number | undefined,
  ): Promise<OrdemCompraInformacaoFaturamentoDropDown[]> {
    if (idOrdemCompra === undefined) throw new Error('Falha ao obter id de ordem de compra!');
    return await this.repository.getOrdemCompraInformacaoFaturamentoDropDown(idOrdemCompra);
  }
}
